import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addTables } from "store/actions/staffAction";

const AddTable = ({ isOpen, toggle }) => {
  const dispatch = useDispatch();
  const { tablesData, isLoading } = useSelector((state) => state.staff);
  const { user } = useSelector((state) => state.auth);
  const [totalTables, setTotalTables] = useState("");
  const [timer, setTimer] = useState("");
  const [timerUnit, setTimerUnit] = useState("Min");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!totalTables || !timer) {
      toast.error("Please fill all fields");
      return;
    }

    if (timerUnit === "Min") {
      if (timer < 20 || timer > 60) {
        toast.error("Minutes must be between 20 and 60");
        return;
      }
    } else if (timerUnit === "Hour") {
      if (timer < 1 || timer > 9) {
        toast.error("Hours must be between 1 and 9");
        return;
      }
    }

    if (totalTables < 1 || totalTables > 99) {
      toast.error("Tables must be between 1 and 99");
      return;
    }

    const formattedTimer = `${timer} ${timerUnit}`;

    try {
      await dispatch(
        addTables(user?.restaurantID, formattedTimer, Number(totalTables))
      );
      toggle();
    } catch (error) {
      toast.error("Failed to add tables");
    }
  };

  const handleTimerChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value) {
      value = Number(value);
    }
    setTimer(value);
  };

  const handleTotalTablesChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value) {
      value = Math.max(1, Math.min(Number(value), 99)); // Max 99 tables
    }
    setTotalTables(value);
  };

  useEffect(() => {
    if (isOpen) {
      setTotalTables(tablesData?.info?.totalTables || "");
      const timerValue = tablesData?.info?.timer || "";
      const match = timerValue.match(/^(\d+)\s*(Min|Hour)$/);
      if (match) {
        setTimer(match[1]);
        setTimerUnit(match[2]);
      } else {
        setTimer("");
        setTimerUnit("Min");
      }
    }
  }, [isOpen, tablesData?.info?.timer, tablesData?.info?.totalTables]);

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {tablesData?.info ? "Update Tables" : "Add Tables"}
      </ModalHeader>
      <ModalBody>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label for="totalTables">Total Tables in Restaurant</Label>
            <Input
              type="number"
              name="totalTables"
              id="totalTables"
              required
              placeholder="Enter total number of tables in restaurant"
              value={totalTables}
              onChange={handleTotalTablesChange}
              min="1"
              max="99" // <-- added max
            />
          </FormGroup>

          <FormGroup>
            <Label for="timer">Per Table Occupy Time</Label>
            <InputGroup>
              <Input
                type="number"
                name="timer"
                id="timer"
                required
                placeholder="Set per table occupy time"
                value={timer}
                onChange={handleTimerChange}
                min={timerUnit === "Min" ? "20" : "1"} // <-- min depends on unit
                max={timerUnit === "Min" ? "60" : "9"} // <-- max depends on unit
                style={{
                  borderTopRightRadius: "0",
                  borderBottomRightRadius: "0",
                }}
              />

              <InputGroupAddon>
                <Input
                  type="select"
                  value={timerUnit}
                  onChange={(e) => setTimerUnit(e.target.value)}
                  style={{
                    borderTopLeftRadius: "0",
                    borderBottomLeftRadius: "0",
                    borderLeft: "0",
                  }}
                >
                  <option>Min</option>
                  <option>Hour</option>
                </Input>
              </InputGroupAddon>
            </InputGroup>
          </FormGroup>

          <div className="d-flex justify-content-end">
            <Button type="submit" color="primary" disabled={isLoading}>
              {isLoading ? (
                <Spinner size="sm" />
              ) : tablesData && (totalTables || timer) ? (
                "Update"
              ) : (
                "Save"
              )}
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default AddTable;
